module.exports = __webpack_public_path__ + "static/media/membership-white.6e5569b4.svg";